module.exports = __webpack_public_path__ + "img/ktb.67cec674.png";